















































import { defineComponent, reactive, } from '@vue/composition-api'

export default defineComponent({
  
  props: {
    errorMessage: {
      type: String,
      required: true,
    }
  },

  setup(props, context) {
    const state = reactive<{
      roomName: string;
    }>({
      roomName: '',
    })

    function searchRoom(): void {
      context.emit('searchRoom', state.roomName)
    }

    function cancel(): void {
      context.emit('cancel')
    }

    return {
      state,
      searchRoom,
      cancel,
    }
  }
})
